import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatIncludes() {
  const packages = [{
    title: 'Arte Primaria',
    subtitle: 'Nivel Primaria',
    description: 'Material lúdico y estructurado para introducir a los niños en el mundo del Arte.',
    image: 'https://cdn.magicpatterns.com/uploads/aVYrb8HEFan8naTYPt86QN/ChatGPT_Image_22_feb_2026,_06_07_02_p.m..png',
    features: ['Planificaciones semanales detalladas', 'Actividades lúdicas y creativas', 'Proyectos cortos de producción artística', 'Evaluaciones adaptadas por edad'],
    color: 'orange'
  }, {
    title: 'Arte Secundaria',
    subtitle: 'Nivel Secundaria',
    description: 'Desafíos creativos y técnicos para adolescentes, enfocados en la expresión y la producción artística.',
    image: 'https://cdn.magicpatterns.com/uploads/d84UfyqtmXGL8gypGkiNB5/ChatGPT_Image_22_feb_2026,_06_08_30_p.m..png',
    features: ['Planificaciones anuales completas', 'Técnicas y lenguajes artísticos avanzados', 'Guías de creación y producción artística', 'Proyectos de muestra / exposición final'],
    color: 'red',
    popular: true
  }, {
    title: 'Bonos Exclusivos',
    subtitle: 'Bonos Exclusivos',
    description: 'Recursos extra para enriquecer tus clases y profesionalizar tu trabajo docente.',
    image: 'https://cdn.magicpatterns.com/uploads/mpLFGoqeZAowD7AmE5rf1X/ChatGPT_Image_22_feb_2026,_06_10_05_p.m..png',
    features: ['Planificaciones Anuales completas para Primaria', 'Planificaciones Anuales completas para Secundaria', 'Proyectos Anuales completos para Primaria', 'Proyectos Anuales completos para Secundaria'],
    color: 'yellow'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="incluye" className="w-full bg-gray-50 py-20 px-4" data-id="element-112">
      <div className="max-w-7xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-114">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-115">
            ¿Qué Incluye el Mega Pack?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-116">
            Todo lo que necesitás para tus clases, dividido por niveles y
            objetivos.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-117">
          {packages.map((pkg, index) => <motion.div key={index} variants={itemVariants} className="relative bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-118">
              <div className="p-6" data-id="element-119">
                <div className="mb-6" data-id="element-120">
                  <img src={pkg.image} alt={`${pkg.title} - ${pkg.description}`} className="w-full h-64 object-cover rounded-lg" data-id="element-121" />
                </div>

                <div className="mb-4" data-id="element-122">
                  <span className="text-xs font-bold text-red-700 uppercase tracking-wide" data-id="element-123">
                    {pkg.subtitle}
                  </span>
                  <h3 className="text-2xl font-bold text-gray-900 mt-1 mb-3" data-id="element-124">
                    {pkg.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-125">{pkg.description}</p>
                </div>

                <ul className="space-y-3" role="list" data-id="element-126">
                  {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start text-sm" data-id="element-127">
                      <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-128" />
                      <span className="text-gray-700" data-id="element-129">{feature}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}